// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"8ebd0571","500":"bd9efd07","592":"599f76a2"}[chunkId] + ".chunk.js";
};